import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const NanoPlayer: any;

@Component({
    selector: 'app-nano-player',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './nano-player.component.html',
    styleUrl: './nano-player.component.scss'
})
export class NanoPlayerComponent implements AfterViewInit, OnDestroy {
    @Input()
    streamId!: string;

    private nanoPlayer: unknown;

    ngAfterViewInit(): void {
        this.initPlayer();
    }
    ngOnDestroy(): void {
        if (this.nanoPlayer) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
            (this.nanoPlayer as any).destroy();
        }
    }

    private initPlayer(): void {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-assignment
        const player = new NanoPlayer('player');

        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any
        (player.setup(this.buildNanoPlayerConfig(this.streamId)) as Promise<any>).then(
            (config) => {
                // eslint-disable-next-line @typescript-eslint/no-magic-numbers,no-console
                console.log(`NanoPlayer setup succeeded with config: ${JSON.stringify(config, undefined, 4)}`);
                this.nanoPlayer = player;
            },
            (error) => {
                // eslint-disable-next-line no-console
                console.log('NanoPlayer setup failed', error);
            }
        );
    }

    private buildNanoPlayerConfig(streamId: string): object {
        return {
            source: {
                entries: [
                    {
                        bintu: {
                            streamid: streamId
                        }
                    }
                ]
            }
        };
    }
}
